import styled, { keyframes } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

const wrapperAnimation = keyframes`
  from {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const animation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  10% {
    opacity: 1;
    transform: scale(1) translateY(0px);
  }
  90% {
    opacity: 1;
    transform: scale(1) translateY(0px);
  }
  to {
    opacity: 0;
    transform: scale(1) translateY(-20px);
  }
`;

const Wrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  animation: ${wrapperAnimation} 4s ease-in-out both;
  ${Vertical} {
    animation: ${animation} 3s 0.5s ease-in-out both;
    text-shadow: 0 0 10px currentColor;
  }
`;

type Props = {
  children: React.ReactNode;
};

export const SplashText = ({ children }: Props) => {
  return (
    <Wrapper>
      <Vertical center>{children}</Vertical>
    </Wrapper>
  );
};
